import React, { useState, useEffect } from 'react';
import { Box, Checkbox, CheckboxGroup, Stack, Button, Flex } from '@chakra-ui/react';
import { path } from "ramda";
import { useUpsertDataMutation, useUpdateDecisionMutation } from "../app/api";
import { useSelector } from 'react-redux';

export const NrOfVotes = ({ items, filtered, decision_id, participant_id, activity_id,
  order_nr, next_to_show, show_until, all_done, data_input, done_item, 
  next_done_item, next_btn_visible, is_last }) => {

  const [upsertData] = useUpsertDataMutation();
  const [moveForward] = useUpdateDecisionMutation();
  const texts = useSelector(path(["ui", "ui_texts"]));
  const [votes, setVotes] = useState({});
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    const initial = {};
    items.forEach(item => { initial[item.id] = 0; });
    filtered.forEach(row => { initial[row.input_id] = row.value_number; });
    setVotes(initial);
  }, [items, filtered]);

  const handleToggle = (itemId) => {
    setVotes(prev => ({ ...prev, [itemId]: prev[itemId] ? 0 : 1 }));
    setChanged(true);
  };

  const handleSubmit = () => {
    const data = items.map(item => {
      const existing = filtered.find(r => r.input_id === item.id);
      return {
        value_number: votes[item.id] || 0,
        ...(existing ? { id: existing.id } : {}),
        ...(data_input ? { input_id: data_input } : { input_id: item.id }),
        decision_id, participant_id, activity_id
      };
    });
    upsertData(data);
    setChanged(false);
  };

  const hide_next_btn = (done_item === null || data_input == null)
    ? (show_until > order_nr)
    : !next_btn_visible;

  return items.length ? (
    <Box>
      <CheckboxGroup>
        <Stack spacing={2} mt={2}>
          {items.map(item => (
            <Checkbox
              key={item.id}
              isChecked={!!votes[item.id]}
              onChange={() => handleToggle(item.id)}
              colorScheme="teal"
            >
              {item.value_text}
            </Checkbox>
          ))}
        </Stack>
      </CheckboxGroup>
      <Flex mt={3} gap={2}>
        <Button size="md" colorScheme="teal" onClick={handleSubmit} isDisabled={!changed}>
          {texts.save}
        </Button>
        {(hide_next_btn || !all_done) ? null : (
          <Button size="md" colorScheme="blue" onClick={() => {
            moveForward({
              id: decision_id,
              done: order_nr,
              done_item: next_done_item,
              show_until: next_to_show
            });
          }}>
            {texts.next}
          </Button>
        )}
      </Flex>
    </Box>
  ) : null;
};
